import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for meetingRoom module related message requests.
 */
var MeetingRoomMessageHandler = /** @class */ (function (_super) {
    __extends(MeetingRoomMessageHandler, _super);
    function MeetingRoomMessageHandler(appSdkHost, meetingRoomService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.meetingRoomService = meetingRoomService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    MeetingRoomMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        //getPairedMeetingRoomInfo
        this.registerHandler(SdkMessageTypes.meetingRoom.getPairedMeetingRoomInfo, function () { return formulateSdkResponse(null, _this.meetingRoomService.getPairedMeetingRoomInfo); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meetingRoom.getPairedMeetingRoomInfo, error, scenario);
            },
        });
        //sendCommandToPairedMeetingRoom
        this.registerHandler(SdkMessageTypes.meetingRoom.sendCommandToPairedMeetingRoom, function (_, params) { return formulateSdkResponse(params, _this.meetingRoomService.sendCommandToPairedMeetingRoom); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meetingRoom.sendCommandToPairedMeetingRoom, error, scenario);
            },
        });
    };
    MeetingRoomMessageHandler.prototype.validateDependencies = function () {
        if (!this.meetingRoomService) {
            throw 'No meetingRoomService provided';
        }
    };
    return MeetingRoomMessageHandler;
}(BaseMessageHandler));
export { MeetingRoomMessageHandler };
//# sourceMappingURL=meetingRoom-message-handler.js.map